module.exports = __webpack_public_path__ + "fc21a67ddb9f07317d6f1d6be6378929.svg";